

const Navbar = () => {
    return (
        <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
            <div className='container-fluid'>
                <a className='navbar-brand'>
                    <h1>CloudFlare Social</h1>
                </a>
            </div>
        </nav>
    )
}

export default Navbar